import styled from 'styled-components';

export const FundSummaryContainer = styled.div`
  display: flex;
  margin: ${props => props.theme.spacing.margins.webBase} 0 ${props => props.theme.spacing.margins.webTwiceBase} 0;
  .ant-divider:last-child {
    display: none;
  }
  @media only screen and (max-width: 991px) {
    flex-direction: column;
  }
`;

export const FundSummaryContent = styled.div`
  margin-right: 101px;
  position: relative;
  && img.preloader {
    height:2rem;
    padding:0;
  }
  &::after {
    content: "";
    height: 100%;
    width: 1px;
    position: absolute;
    right: -50px;
    background-color: ${props => props.theme.colors.border};
    top: 0;
  }
  &:last-child:after {
    display: none;
    margin-bottom: 0;
  }
  @media only screen and (max-width: 991px) {
    display: flex;
    flex-direction: ${props => props.isColumn ? 'column' : 'row'};
    justify-content: space-between;
    align-items: ${props => props.isColumn ? 'start' : 'center'};
    margin-right: 0;
    border-bottom: 1px solid ${props => props.theme.colors.border};
    padding: 10px 0;
    &:last-child {
      border-bottom: none;
    }
    &::after {
      right: 0px;
      background-color: unset;
    }
  }
`;